export class CourseMaster {
    public ID: number;
    public HashCode: string;
    public CourseName: string;
    public NoOfYear: number;
    public SectionID:number;
    public CourseTypeID:number;
    public InstituteTypeID:number;
    public YearID: number;
}